exports = module.exports = require("../../../../../../css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".dv-border-box-6{position:relative;width:100%;height:100%}.dv-border-box-6 .dv-border-svg-container{position:absolute;top:0;left:0;width:100%;height:100%}.dv-border-box-6 .dv-border-svg-container>polyline{fill:none;stroke-width:1}.dv-border-box-6 .border-box-content{position:relative;width:100%;height:100%}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/postcss-loader!./~/@jiaminghi/data-view/lib/components/borderBox6/src/main.css
// module id = 1077
// module chunks = 45